import { TextareaControl, SelectControl, InputControl } from "formik-chakra-ui"
import {
    Flex,
    Center,
    Wrap,
    WrapItem,
    useColorModeValue,
    Text,
    ScaleFade,
    Tooltip
} from "@chakra-ui/react";
import { DatePickerField } from "../DatePicker";
import { useAuth } from "../../contexts/AuthContext";
import { QuestionOutlineIcon } from "@chakra-ui/icons";
export default function CustomRequestFields( { values } ){
    const datepickerClass = useColorModeValue("chakra-input css-1c6j008","chakra-input css-xpongc")
    const { marketingSettings } = useAuth()
    const daysNotice =
    values["Request Type"] === "Design"
      ? marketingSettings?.["Task Settings"]?.["Minimum Notice Days"]?.[
          "Design"
        ] ?? 2
      : values["Request Type"] === "Custom"
      ? marketingSettings?.["Task Settings"]?.["Minimum Notice Days"]?.[
          "Custom"
        ] ?? 3
      : values["Request Type"] === "Swag"
      ? marketingSettings?.["Task Settings"]?.["Minimum Notice Days"]?.[
          "Swag"
        ] ?? 2
      : values["Request Type"] === "Video Edit"
      ? marketingSettings?.["Task Settings"]?.["Minimum Notice Days"]?.[
          "Video Edit"
        ] ?? 5
      : 2;

    const showTooltip = ["Design", "Custom", "Video Edit"].includes(
        values["Request Type"]
    );
    
    const dueDateLabel = showTooltip ? (
        <Flex align="center">
        <Text>Needed By Date</Text>
        <Tooltip
            label={`Minimum Required Notice: ${daysNotice} Days`}
            placement="right"
            hasArrow
        >
            <QuestionOutlineIcon ml={2} verticalAlign="middle" />
        </Tooltip>
        </Flex>
    ) : (
        "Due Date"
    );

    return(
        <ScaleFade in initialScale={0.8}>
        <>
        {values['Request Type'] == 'Design' && 
            <Wrap spacing={{base: "5%", md: '2%'}}  mb={3}>
                <WrapItem width={{ base: '43%', md: '23%' }} h={20}>
                    <SelectControl 
                        name="Medium"
                        selectProps={{ placeholder: "Select a medium" }}
                    >
                        <option value="Digital">Digital</option>
                        <option value="Print">Print</option>
                    </SelectControl>
                </WrapItem>
                {values['Medium'] == 'Digital' &&
                    <WrapItem width={{ base: '43%', md: '23%' }} h={20}>
                      <SelectControl 
                          name="Platform"
                          selectProps={{ placeholder: "Select a platform" }}
                      >
                          <option value="Instagram Post">Instagram Post</option>
                          <option value="Facebook Post">Facebook Post</option>
                          <option value="Digital Flyer">Digital Flyer</option>
                          <option value="Other">Other (specify below)</option>
                      </SelectControl>
                  </WrapItem>
                }
              
                {values['Medium'] == 'Print' ? 
                <>

                <WrapItem width={{ base: '65%', md: '40%' }} h={20}>
                <Center><Text pt={1}>Dimensions&nbsp;</Text></Center>

                        <InputControl
                            name="Length"
                            inputProps={{ placeholder: 'Length'}}
                        >
                        </InputControl>
                        &nbsp;
                        <InputControl
                            name="Width"
                            inputProps={{ placeholder: 'Width'}}
                        >
                        </InputControl>
                </WrapItem></> : null }
            </Wrap>
  
        }
            <TextareaControl mb={2} name="Description" label="Describe your request" />
            <Flex w='300px'>
                <DatePickerField 
                    useBusinessDays
                    daysNotice={daysNotice} 
                    w='300px' 
                    name="Due Date" 
                    label={dueDateLabel} 
                    className={datepickerClass}/>
            </Flex>
        </>
        </ScaleFade>
    )
}